<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaIntegrantes"
    :search="search"
    :no-data-text="'Este projeto não possui integrantes.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.nome="props">
        <router-link :to="{ name: 'EditarIntegrante', params: { idProjeto: idProjeto, idParticipante: props.item.idParticipante }}">
          {{ props.item.nome }}
        </router-link>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaIntegrantes.length }} integrantes
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>
    <v-card-actions v-if="projeto.funcao != null && projeto.funcao.item === 1">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="toNovoIntegrante" >Adicionar</v-btn>
      <v-btn color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    listaIntegrantes: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'center', value: 'nome' },
      { text: 'Função', align: 'center', value: 'funcao.descricao' },
      { text: 'Vínculo', align: 'center', value: 'vinculo' },
      { text: 'CH semanal', align: 'center', value: 'cargaHoraria' },
      { text: 'Data de entrada', align: 'center', value: 'dataEntrada' },
      { text: 'Data de saída', align: 'center', value: 'dataSaida' }
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toNovoIntegrante: function () {
      this.$router.push({ name: 'NovoIntegrante', params: {idProjeto: this.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'EditarAtividades', params: {idProjeto: this.projeto.idProjeto} })
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
    projetos.getIntegrantesDoProjeto(this.idProjeto)
    .then(response => {
      this.listaIntegrantes = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-editar-integrantes.vue?491bebec